<template>
  <span class="inline-high-value" data-row-action @click.stop @keydown.stop>
    <v-menu v-model="menu" offset-y :disabled="saving">
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="high-value-edit" v-bind="attrs" v-on="on" :disabled="saving"
          :aria-label="`Edit High Value status for ${lead.customer_name || 'lead ' + lead.id}`">
          <high-value-badge :value="lead.is_high_value" />
          <i class="mdi mdi-pencil-outline" aria-hidden="true"></i>
        </button>
      </template>
      <v-list dense>
        <v-list-item :disabled="saving" @click.stop="save(true)"><v-list-item-title>High Value</v-list-item-title><v-icon v-if="lead.is_high_value == 1" small>mdi-check</v-icon></v-list-item>
        <v-list-item :disabled="saving" @click.stop="save(false)"><v-list-item-title>Not High Value</v-list-item-title><v-icon v-if="lead.is_high_value != 1" small>mdi-check</v-icon></v-list-item>
      </v-list>
    </v-menu>
    <span v-if="saving || notice" class="save-status" role="status">{{ saving ? 'Saving…' : notice }}</span>
    <span v-if="error" class="save-error" role="alert">{{ error }}</span>
  </span>
</template>

<script>
import axios from 'axios'
import HighValueBadge from '@/components/common/HighValueBadge.vue'

export default {
  name: 'InlineHighValue',
  components: { HighValueBadge },
  props: {
    lead: { type: Object, required: true },
    reportUuid: { type: String, default: null }
  },
  data() { return { menu: false, saving: false, error: '', notice: '' } },
  methods: {
    async save(value) {
      if (this.saving) return
      this.menu = false
      this.saving = true
      this.error = ''
      this.notice = ''
      try {
        const payload = { lead_id: this.lead.id, is_high_value: value }
        let response
        if (this.reportUuid !== null) {
          response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/public-lead-qualification`, {
            ...payload, report_uuid: this.reportUuid, field: 'high_value'
          })
        } else {
          response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/lead-survey-instructions`, {
            ...payload, action: 'manual'
          }, { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } })
        }
        this.$emit('saved', response.data)
        this.notice = 'Saved'
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || 'Could not save High Value status. Please try again.'
      } finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.inline-high-value { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 5px; }
.high-value-edit { display: inline-flex; align-items: center; gap: 4px; border-radius: 999px; color: #64748b; }
.high-value-edit:hover { background: #f1f5f9; }
.high-value-edit:focus-visible { outline: 2px solid #276472; outline-offset: 2px; }
.high-value-edit:disabled { opacity: .55; cursor: wait; }
.save-status { font-size: 12px; color: #64748b; }
.save-error { font-size: 12px; color: #b91c1c; }
</style>
